module.exports = __webpack_public_path__ + "912bc70f63aedb7d5d134709eb48320b.MP3";